import { useEffect, useRef, useState } from "react";

import { getChunkById } from "features/medical-scribe/medical-scribe-db/medical-scribe-db.util";
import { recordToDataUrl } from "features/medical-scribe/utils";

/**
 * A playable URL for a recording kept only in this browser's IndexedDB. The read is async and
 * outside React's data flow, so it needs state; the URL is revoked when the recording changes or
 * the details close.
 */
export default function useLocalScribeAudioUrl(localId: string | undefined) {
  const [localBlobUrl, setLocalBlobUrl] = useState<string | undefined>();
  const audioObjectUrlRef = useRef<string | undefined>();

  useEffect(() => {
    if (localId) {
      getChunkById(String(localId)).then((result) => {
        if (result?.id) {
          const objectUrl = recordToDataUrl(result.chunks);
          audioObjectUrlRef.current = objectUrl;
          setLocalBlobUrl(objectUrl);
        }
      });
    }

    return () => {
      if (audioObjectUrlRef.current) {
        URL.revokeObjectURL(audioObjectUrlRef.current);
        audioObjectUrlRef.current = undefined;
      }
    };
  }, [localId]);

  return localBlobUrl;
}
